'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validators = require('vuelidate/lib/validators');

exports.default = {
    data: function data() {
        return {};
    },
    mounted: function mounted() {
        this.$notify({
            title: this.type,
            message: this.message,
            type: this.type,
            offset: parseInt(this.offset),
            customClass: this.type
        });
    },

    props: ['type', 'message', 'offset']
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/message.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/message.vue
// module chunks = 0